class CountdownManager {
  constructor() {
    this.elements = [];
    this.intervalId = null;
  }

  // Parse timezone from datetime string or default to AEDT/AEST
  parseTimezone(datetimeStr) {
    const upperStr = datetimeStr.toUpperCase();
    if (upperStr.includes('AEDT')) return 'AEDT';
    if (upperStr.includes('AEST')) return 'AEST';
    
    // Auto-detect AEDT/AEST based on Australian DST rules
    // DST starts first Sunday in October, ends first Sunday in April
    const now = new Date();
    const year = now.getFullYear();
    
    // Find first Sunday in October
    const octFirst = new Date(year, 9, 1); // October is month 9
    const octFirstSunday = new Date(year, 9, 1 + (7 - octFirst.getDay()) % 7);
    octFirstSunday.setHours(2, 0, 0, 0);
    
    // Find first Sunday in April (next year if we're past October)
    const aprYear = now >= octFirstSunday ? year + 1 : year;
    const aprFirst = new Date(aprYear, 3, 1); // April is month 3
    const aprFirstSunday = new Date(aprYear, 3, 1 + (7 - aprFirst.getDay()) % 7);
    aprFirstSunday.setHours(3, 0, 0, 0);
    
    // Check if current time is in DST period
    const isDST = now >= octFirstSunday && now < aprFirstSunday;
    return isDST ? 'AEDT' : 'AEST';
  }

  // Convert datetime string to UTC timestamp
  parseDateTime(datetimeStr) {
    console.log('datetimeStr', datetimeStr);
    // Remove timezone suffix if present
    const cleanStr = datetimeStr.replace(/\s*(AEDT|AEST)\s*$/i, '').trim();
    const timezone = this.parseTimezone(datetimeStr);
    
    // Parse MM/DD/YYYY HH:mm:ss AM/PM format
    const [datePart, timePart] = cleanStr.split(' ');
    const [month, day, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    let hours24 = hours;
    if (datetimeStr.includes('PM') && hours !== 12) {
      hours24 = hours + 12;
    } else if (timePart.includes('AM') && hours === 12) {
      hours24 = 0;
    }
    console.log('hours24', hours24);

    // AEDT is UTC+11, AEST is UTC+10
    const offset = timezone === 'AEDT' ? 11 : 10;
    
    // Create date in UTC by subtracting the offset
    const utcDate = new Date(Date.UTC(
      year,
      month - 1,
      day,
      hours24 - offset,
      minutes,
      seconds
    ));
    
    return utcDate.getTime();
  }

  // Format countdown as DD:HH:mm:ss
  formatCountdown(milliseconds) {
    if (milliseconds <= 0) return '00 : 00 : 00 : 00';
    
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return `${String(days).padStart(2, '0')} : ${String(hours).padStart(2, '0')} : ${String(minutes).padStart(2, '0')} : ${String(seconds).padStart(2, '0')}`;
  }

  // Initialize all countdown elements
  init() {
    // Query all elements with countdown data
    const countdownElements = document.querySelectorAll('[data-countdown-datetime]');
    
    // Prepare elements array with parsed data
    this.elements = Array.from(countdownElements).map(el => {
      const datetimeStr = el.getAttribute('data-countdown-datetime');
      const targetTime = this.parseDateTime(datetimeStr);
      
      // Remove 'hidden' class to show the element
      el.classList.remove('hidden');
      
      return {
        element: el,
        targetTime: targetTime
      };
    });
    
    // Initial update
    this.update();
    
    // Start interval (update every second)
    this.intervalId = setInterval(() => this.update(), 1000);
  }

  // Update all countdowns
  update() {
    const now = Date.now();
    
    // Filter out expired elements and update only active ones
    this.elements = this.elements.filter(({ element, targetTime }) => {
      console.log('targetTime', new Date(targetTime));
      console.log('now', new Date(now));

      const remaining = targetTime - now;
      
      if (remaining <= 0) {
        // Set final state and mark as expired
        element.textContent = this.formatCountdown(0);
        element.classList.add('expired');
        const sectionId = element.getAttribute('data-section-id');
        if (sectionId) {
          const saleDateLabel = document.querySelector(`.section-${sectionId} .pd-a-spot-regular__sale-date-label`);
          if (saleDateLabel) {
            saleDateLabel.classList.add('hidden');
          }
          const saleIsLiveLabel = document.querySelector(`.section-${sectionId} .pd-a-spot-regular__sale-is-live-label`);
          if (saleIsLiveLabel) {
            saleIsLiveLabel.classList.remove('hidden');
          }
        }
        return false; // Remove from active elements
      }
      
      // Update element text
      element.textContent = this.formatCountdown(remaining);
      return true; // Keep in active elements
    });
    
    // Stop interval if no active countdowns remain
    if (this.elements.length === 0) {
      this.destroy();
    }
  }

  // Cleanup method
  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.countdownManager = new CountdownManager();
    window.countdownManager.init();
  });
} else {
  window.countdownManager = new CountdownManager();
  window.countdownManager.init();
}

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  if (window.countdownManager) {
    window.countdownManager.destroy();
  }
});